import { InterruptedCashinNotice } from './InterruptedCashinNotice';
import { useInterruptedCashinSession } from './InterruptedCashinProvider';

export const InterruptedCashinHost = () => {
  const { notice, dismiss } = useInterruptedCashinSession();

  if (!notice) {
    return null;
  }

  return <InterruptedCashinNotice notice={notice} onClose={dismiss} />;
};
